import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";

@Component({
  selector: 'app-exclusive-collections',
  templateUrl: './exclusive-collections.component.html',
  styleUrls: ['./exclusive-collections.component.scss']
})
export class ExclusiveCollectionsComponent implements OnInit {
  slidesData: any = [];
  exclusiveData: any = [
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
  ];
 loader = false;
  constructor(private dataService: DataService,) { }

  getSEOImage(url: string): string {
    return buildSEOImageUrl(url);
  }

  async ngOnInit() {
    (await this.dataService.getExclusiveBannerService()).subscribe((singleservice) => {
      this.slidesData = [];
      this.slidesData = singleservice;
    });

    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.exclusiveData = [];

        this.exclusiveData = singleservice.filter((data)=>{
          return data["isExclusive"]
        })

        //console.log(this.exclusiveData);
      }
    );
  }

}
